import { defineMessages } from 'react-intl-next';

import { messages as messagesOtherIndividual } from './messages-only-other';
import { messages as messagesYouOnly } from './messages-only-you';
import { messages as messagesYouAndManyOthers } from './messages-you-and-many-others';
import { messages as messagesYouAndOneOther } from './messages-you-and-one-other';

/**
 * There are a LOT of messages here due to the joys of i18n. They roughly fall into the following categories"
 *  -> Single person that isn't you performed an action (one for each verb and time period combination)
 *  -> Single person that is you performed an action (one for each verb and time period combination)
 *  -> Two people performed an action (one for including you, and one for not including you)
 *  -> Three people performed an action (one for including you, and one for not including you)
 *  -> More than three people performed an action (one for including you, and one for not including you)
 */

const otherMsg = defineMessages({
	privacyAssuringInfoText: {
		id: 'ptc-directory.work-activity.privacy-assurity',
		defaultMessage: 'Others will only see what they can access.',
		description:
			'Appears next to a list of recently worked on items on a user’s own profile page. Only appears when viewing yourself. Text assuring the user that private activity items will not appear to others who view this page. Visibility is subject to each individual’s privileges.',
	},
});

export const messages = {
	...otherMsg,
	...messagesOtherIndividual,
	...messagesYouOnly,
	...messagesYouAndOneOther,
	...messagesYouAndManyOthers,
};
